<template>
  <div class="upcoming-job">
    <div class="modal upcoming-job-modal" v-if="t">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
      <div class="modal-card">
        <section class="modal-card-body has-text-left">
          <span class="tags has-addons has-text-weight-semibold is-pulled-right">
            <span class="tag is-link">Trip ID</span>
            <span class="tag is-grey">{{ tripID(t) }}</span>
          </span>
          <h1
            class="has-text-link is-size-5 has-text-weight-semibold"
          >{{ $t("driver.upcoming-job") }}</h1>
          <p class="has-text-grey has-text-weight-semibold">{{t.workflow_type_name}}</p>

          <div class="media-content" style="padding-top:10px">
            <p>
              <i class="fa fa-clock has-text-warning" />
              {{ longScheduledTime(t) }}
              <span
                class="tag has-text-weight-semibold"
              >{{humanTime(t)}}</span>
            </p>
            <p>
              <i class="fa fa-map-marker-alt has-text-primary" />
              &nbsp;{{ $t("driver.pickup-at") }}
              <a
                :href="pickupMapURL"
                target="_blank"
              >
                {{ transaction.data.pickup_stop.name }}
                <i class="fa fa-map" />
              </a>
            </p>
            <p v-if="transaction.data.dropoff_stop">
              <i class="fa fa-long-arrow-alt-down has-text-grey" />
              <br />
              <i class="fa fa-map-marker-alt has-text-link" />
              &nbsp;{{ $t("driver.dropoff-at") }}
              <a
                :href="dropoffMapURL"
                target="_blank"
              >
                {{ transaction.data.dropoff_stop.name }}
                <i class="fa fa-map" />
              </a>
            </p>
            <p>
              <i class="fa fa-coins has-text-success" />
              &nbsp;
              <span>
                <span>{{ prettyFare(t) }}</span>&nbsp;
                <span v-if="isPrepaid(t)" class="tag is-grey has-text-weight-semibold">Prepaid</span>
              </span>
            </p>
            <p v-if="customerName(t)">
              <i class="fa fa-user has-text-grey" />
              &nbsp;
              <span>
                <span>Customer {{ customerName(t) }}</span>&nbsp;
                <a @click="callCustomer(t)">
                  <i class="fa fa-phone" />
                </a>
              </span>
            </p>
          </div>
          <hr />

          <!-- <div v-if="!isEditing">
            <span
              class="button is-warning is-rounded is-fullwidth"
              @click="edit"
            >{{ $t("driver.change-driver") }}</span>
          </div>
          <div v-else>
            <div class="columns is-mobile">
              <div class="column" style="max-width:45vw">
                <div class="field">
                  <div class="control has-icons-left">
                    <span class="icon is-small is-left">
                      <i class="fa fa-calendar-alt" />
                    </span>

                    <b-datepicker rounded v-model="date" :min-date="today" :max-date="maxDate"></b-datepicker>
                  </div>
                </div>
              </div>
              <div class="column" style="max-width:45vw">
                <div class="field">
                  <div class="control has-icons-left">
                    <span class="icon is-small is-left">
                      <i class="fas fa-clock" />
                    </span>
                    <b-timepicker rounded v-model="time" hour-format="24" :incrementMinutes="5"></b-timepicker>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <br />
              <span
                class="button is-success is-rounded is-fullwidth"
                @click="submitTimeChange"
              >{{ $t("submit") }}</span>
            </div>
          </div>-->

          <!-- <br />
          <div>
            <span
              class="button is-danger is-rounded is-outlined is-small"
              @click="cancel"
            >{{ $t("cancel-job") }}</span>
          </div>
          <hr />-->
          <div>
            <i class="has-text-link">{{ $t("passenger.need-help-with-ride")}}</i>
            <br />
            <a
              class="button is-link is-rounded is-outlined is-small"
              href="https://m.me/tukapp"
              style="width: 45vw; flex:box"
            >
              <i class="fab fa-facebook-messenger is-small" />
              &nbsp;{{ $t("profile.support") }}
            </a>
            <span
              class="button is-danger is-rounded is-outlined is-small is-pulled-right"
              @click="cancel"
            >{{ $t("cancel-job") }}</span>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "UpcomingJobModal",
  data() {
    var d = new Date();
    return {
      transaction: null,
      isEditing: false,
      date: null,
      time: null,
      today: d,
      maxDate: new Date(d.getFullYear(), d.getMonth(), d.getDate() + 5),
    };
  },
  computed: {
    t() {
      return this.transaction;
    },
    pickupMapURL() {
      var lat = this.t.data.pickup_stop.lat;
      var lon = this.t.data.pickup_stop.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    dropoffMapURL() {
      var lat = this.t.data.dropoff_stop.lat;
      var lon = this.t.data.dropoff_stop.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    driverPic() {
      var driver = this.t.driver;
      if (!driver.profile_pic_url || driver.profile_pic_url === "") {
        return this.$store.state.birdProfilePic;
      }
      return driver.profile_pic_url;
    },
    prettyDate() {
      if (this.date) return this.date.toLocaleDateString();
      return false;
    },
    prettyTime() {
      if (this.time) {
        return this.date.toLocaleTimeString();
      }
      return false;
    },
    newTime() {
      if (!(this.date || this.time)) return null;
      var dt = this.date;
      dt.setHours(this.time.getHours());
      dt.setMinutes(this.time.getMinutes());
      if (dt < new Date()) return null; // can't be in the past
      return dt;
    },
  },
  mounted() {
    EventBus.$on("UPCOMING_JOB", (t) => {
      this.transaction = t;
      console.log("EDIT_TRANSACTION", t);
    });
  },
  methods: {
    closeModal() {
      this.isEditing = false;
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    tripID(t) {
      return t.id.substr(t.id.length - 5);
    },
    isPrepaid(t) {
      if (!t.data.fare) return false;
      if (t.data.fare.cash > 0) return false;
      return true; // means cash === 0
    },
    driverName(t) {
      if (!t.driver) return null;
      return t.driver.name;
    },
    customerName(t) {
      if (!t.customer) return null;
      return t.customer.name;
    },
    callCustomer(t) {
      var mobile = t.customer.phone_number;
      window.location.href = `tel:${mobile}`;
    },
    edit() {
      this.isEditing = true;
      var dt = new Date(this.t.data.scheduled_time);
      this.date = dt;
      this.time = dt;
    },
    cancel() {
      this.$swal({
        title: this.$t("passenger.cancel-are-you-sure"),
        html: '<i class="fa fa-question fa-4x" />',
        showCancelButton: true,
        confirmButtonColor: "#f36",
        cancelButtonColor: "#00D1B2",
        cancelButtonText: this.$t("no"),
        confirmButtonText: this.$t("yes-cancel"),
      }).then((val) => {
        if (val.value) {
          var loader = this.loadingDots();
          this.$store
            .dispatch("patchTransaction", {
              transactionID: this.transaction.id,
              data: {
                state: "cancelled_by_driver",
              },
            })
            .then(() => {
              this.console("cancelled upcoming job");
              this.updateTrips();
            })
            .catch((err) => this.apiError(err))
            .finally(() => {
              loader.hide();
              this.closeModal();
            });
        }
      });
    },
    cancelOptions() {
      var arr = [
        "fare-high",
        "driver-far",
        "no-driver",
        "changed-mind",
        "other",
        "dont-cancel",
      ];
      var o = {};
      arr.forEach((title) => {
        o[title] = this.$t(`cancel-reasons.${title}`);
      });
      return o;
    },
    callDriver() {
      var mobile = this.t.driver.phone_number;
      window.location.href = `tel:${mobile}`;
    },
    chat() {
      this.$swal({
        text: this.$t("chat-coming-soon"), //"In-app chat messaging coming soon!"
      });
    },
    prettyFare(t) {
      if (t.data.fare) {
        if (t.data.fare.cash > 0) {
          return `฿ ${t.data.fare.cash} via Cash`;
        }
        return `฿ ${t.data.fare.tukpay} via TukPay`;
      }
      return "Free of Charge";
    },
    submitTimeChange() {
      if (!this.newTime) {
        alert("Please set a correct time");
        return;
      }
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.transaction.id,
          data: {
            data: { acknowledged: false, scheduled_time: this.newTime },
          },
        })
        .then(() => this.updateTrips())
        .catch((err) => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.closeModal();
        });
    },
  },
};
</script>

<style scoped>
.upcoming-job {
  color: black;
}
.modal-card-body {
  border-radius: 25px;
}
.field {
  display: block;
  margin: auto;
}
img {
  border-radius: 8px;
  border: 2px solid gold;
  height: 80px;
  width: auto;
}
div.card-content {
  padding: 6px;
  overflow: hidden !important;
}
.columns,
.columns:last-child {
  margin: 0;
  padding: 0;
}
.column {
  padding: 2px;
}
.tag {
  padding: 0 6px;
}
hr {
  margin: 10px 0;
}
.icon.is-left {
  /* padding: 0 0;
  width: 0.5em; */
}
</style>